import React from 'react';

//左のデザイン画像
const LEFT_IMG = 1
//右のデザイン画像
const RIGHT_IMG = 2

class Step4 extends React.Component {

	//og:imageの表示有無の文字列を取得
	getDispOgImageStr(){
		if(this.props.isDispOgImage){
			return "表示する"
		}else{
			return "表示しない"
		}
	}

	//検索欄のデザインタイプの文字列を取得
	getSearchFormDesignStr(){
		if(this.props.searchFormDesign == LEFT_IMG){
			return "検索フォーム"
		}else if(this.props.searchFormDesign == RIGHT_IMG){
			return "検索フォーム＋ボタン"
		}
	}

	render() {
	  return (
			<div id="contents_body">
				<p>
					以下の設定内容でサイト内を設置します。この内容でよろしければ、「適用」をクリックして下さい。
				</p>
				<form className="attention-box">
					<p>対象ドメイン：https://{this.props.searchdomain}</p>
					<p>og:imageによる画像表示：{this.getDispOgImageStr()}</p>
					<p>デフォルトの検索表示件数：{this.props.dispSearchNum}</p>
					<p>サイト内検索のデザイン：{this.getSearchFormDesignStr()}</p>
				</form>
			</div>
		);
  }
}

export default Step4;